import React, { ReactElement } from 'react';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { LinkButton } from '../linkButton';
import { colors } from '../../../styles/variables';

import styles from './invoiceDealInstructions.module.scss';

export const InvoiceDealInstructions = (): ReactElement => {
  const href = 'https://www.notion.so/sightx/Deals-in-the-Invoice-Hub-af6cfd5f56d14c4c9882e48e2a7decf7';
  return (
    <div className={styles.instructions}>
      <LinkButton className={styles.link} href={href} target='_blank'>
        <span className={styles.text}>I can't find my deal</span>
        <QuestionCircleOutlined style={{ color: colors.sightxPurple400 }}/>
      </LinkButton>
    </div>
  );
};
